<template>
 <div>
   <div class="tag-box" :class="{'box-info':matchType==='exact','box-warning':matchType==='phrase','box-success':matchType==='broad'}">
    <span class="tag-content" :class="{'info':matchType==='exact','warning':matchType==='phrase','success':matchType==='broad'}">{{mapFun(matchType,matchList)}}</span>
   </div>
 </div>
</template>

<script>
export default {
  props: {
    matchType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      matchList: [{
        label: '精确',
        value: 'exact'
      },
      {
        label: '精确',
        value: 'EXACT'
      },
      {
        label: '词组',
        value: 'phrase'
      },
      {
        label: '词组',
        value: 'PHRASE'
      },
      {
        label: '广泛',
        value: 'broad'
      },
      {
        label: '广泛',
        value: 'BROAD'
      },
      {
        label: '自动',
        value: 'auto'
      },
      {
        label: '手动',
        value: 'manual'
      },
      {
        label: '紧密匹配',
        value: 'close-match'
      },
      {
        label: '宽泛匹配',
        value: 'loose-match'
      },
      {
        label: '同类商品',
        value: 'similar product'
      },
      {
        label: '同类商品',
        value: 'complements'
      },
      {
        label: '替代商品',
        value: 'substitutes'
      }],
    }
  },
  computed: {
    matchTypeColor() {
      return this.matchType === 'exact' ? '#4EB92A' : this.matchType === 'phrase' ? '#FF763B' : '#4687F3'
    }
  },
  mounted() {

  },

  methods: {
    mapFun(val, arr) {
      const tempItem = arr.find(item => item.value === val)
      return tempItem?.label || '-'
    },
  }
}
</script>

<style scoped lang='scss'>
.tag-box{
  border-radius: 2px;
  width: 32px;
  height: 22px;
  line-height: 22px;
  text-align: center;
}
.box-success{
  background:rgba(59, 108, 253 ,0.1) ;
  border: 1px solid rgba(59, 108, 253 ,0.2);
}
.box-info{
  background:rgba(78, 185, 42 ,0.1) ;
  border: 1px solid rgba(78, 185, 42 ,0.2);
}
.box-warning{
  background:rgba(255, 118, 59 ,0.1) ;
  border: 1px solid rgba(255, 118, 59  ,0.2);
}
.tag-content{
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.success{
  color:#4687F3
}
.info{
  color:#4EB92A
}
.warning{
 color :#FF763B
}
</style>
